import React from "react";
import PropTypes from "prop-types";

import { BrowserRouter, Route } from "react-router-dom";

import Filters from "./filters/Filters";
import EventSearch from "./EventSearch";
import EventSearchTeaser from "./EventSearchTeaser";
import EventSearchPager from "./EventSearchPager";

import FiltersConverterService from "./services/FiltersConverterService";
import EventSearchService from "./services/EventSearchService";

class EventSearchOverview extends React.Component {
  constructor(props) {
    super(props);

    const { agendaPath } = window;

    this.state = {
      loading: false,
      results: [],
      pagination: {
        currentPage: 0,
        total: 0,
        totalPages: 0,
      },
    };

    this.basePath = agendaPath || "/uitagenda";
    this.filters = window.filters;
    this.filterConverters = {
      search: FiltersConverterService.converters.textConverter,
      labels: FiltersConverterService.converters.radioConverter,
      date_ranges: FiltersConverterService.converters.radioConverter,
      day: FiltersConverterService.converters.textConverter,
      month: FiltersConverterService.converters.textConverter,
      year: FiltersConverterService.converters.textConverter,
      topics: FiltersConverterService.converters.radioConverter,
    };
  }

  componentDidMount = () => {
    this.search().then();
  };

  componentDidUpdate = (prevProps) => {
    /* eslint-disable */
    const hasUpdatedFilters =
      this.props.location.pathname !== prevProps.location.pathname;
    const hasUpdatedPage = this.props.location.hash !== prevProps.location.hash;

    if (hasUpdatedFilters || hasUpdatedPage) {
      this.search().then();
    }
    /* eslint-enable */
  };

  search = async () => {
    const values = this.getFilterValues();
    const page = this.getPage();

    const timeout = setTimeout(() => {
      this.setState({ loading: true });
    }, 400);

    this.setState(
      {
        ...(await EventSearchService.search(values, page)),
        loading: false,
      },
      () => {
        window.clearTimeout(timeout);
      }
    );
  };

  getFilterValues = () => {
    const {
      location: { pathname },
    } = this.props;

    const filtersString = pathname.replace(this.basePath, "");

    return FiltersConverterService.parse(
      filtersString,
      this.filters,
      this.filterConverters
    );
  };

  setFilterValues = (values) => {
    const { history } = this.props;

    history.push(
      `${this.basePath}/${FiltersConverterService.stringify(
        values,
        this.filters,
        this.filterConverters
      )}`
    );
  };

  getPage = () => {
    const hash = window.location.hash.replace("#", "");

    return isNaN(+hash) ? 0 : +hash; // eslint-disable-line
  };

  setPage = (page) => {
    window.location.hash = page - 1;
  };

  showResults = () => {
    if (window.toggleFilterPageSidebar) {
      window.toggleFilterPageSidebar();
    }
  };

  render = () => {
    const { loading, results, pagination } = this.state;

    const sidebar = (
      <Filters
        filters={this.filters}
        values={this.getFilterValues()}
        setValues={this.setFilterValues}
        showResults={this.showResults}
      />
    );

    const content = (
      <>
        <div className="event-search-topbar">
          <div className="event-search-topbar__results">
            <strong>{pagination.total}</strong>{" "}
            {pagination.total === 1 ? "resultaat" : "resultaten"}
          </div>
        </div>
        <div className="event-list">
          {results.map((event) => (
            <React.Fragment key={event.url}>
              <EventSearchTeaser event={event} />
            </React.Fragment>
          ))}
        </div>
        {pagination.totalPages > 1 && (
          <EventSearchPager
            pageCount={pagination.totalPages}
            activePage={pagination.currentPage + 1}
            changePage={this.setPage}
          />
        )}
      </>
    );

    return (
      <EventSearch loading={loading} sidebar={sidebar} content={content} />
    );
  };
}

const EventSearchOverviewWithRouter = () => (
  <BrowserRouter>
    <Route path="/" component={EventSearchOverview} />
  </BrowserRouter>
);

EventSearchOverview.propTypes = {
  location: PropTypes.objectOf(PropTypes.any).isRequired,
  history: PropTypes.shape({}).isRequired,
};

export default EventSearchOverviewWithRouter;
